import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../../shared/dialog/dialog.styles';
import { withPatientIvStatusDialogProvider } from '../../../hooks/use-patient-iv-status-dialog/hoc';
import { usePatientIvStatusDialog } from '../../../hooks/use-patient-iv-status-dialog/hook';
import { PatientIvStatusDialog } from '../../patient-iv-status-dialog';
import { AppointmentEndedMessage } from '../../shared/appointment-ended-message/appointment-ended-message';
import { ManuallyVerifiedButton } from '../../shared/manually-verified-button';
import { RunVerificationButton } from '../../shared/run-verification-button';
import { SelfPayButton } from '../../shared/self-pay-button';
import { BoldText } from '../../styles';

const PayerUnableToRespondStatusDialog: FC = (props) => {
  const { opened, onClose, isLoading, patientInfo, selectedIvSummary, appointment } = usePatientIvStatusDialog();

  return (
    <PatientIvStatusDialog
      opened={opened}
      title="Needs Attention"
      subtitle={
        <>
          <BoldText>{`${patientInfo?.firstName} ${patientInfo?.lastName}`}</BoldText>
          {selectedIvSummary?.dateReceived && (
            <>&nbsp;- Run {moment.utc(selectedIvSummary.dateReceived).local().format('MMM D hA')}</>
          )}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '10px 0 20px 0', display: 'block' }}>
        We were unable to confirm the verification status of this patient due to unresponsive systems from the payer.
        Please reach out to the payer directly to manually verify the patient or mark them as self-pay.
      </DialogSubTitle>
      <AppointmentEndedMessage />
      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <SelfPayButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <RunVerificationButton onSuccess={async () => onClose()} disabled={isLoading || appointment?.isEnded} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </PatientIvStatusDialog>
  );
};

export default withPatientIvStatusDialogProvider(PayerUnableToRespondStatusDialog);
